module.exports = __webpack_public_path__ + "static/media/Intruded tooth 4.ac88a691.png";